export const TLP_MAX_WIDTH = 1200;
